import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { lightGreen, red } from '@mui/material/colors';
import { useLayout } from '../../context/LayoutContext';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { toast } from 'react-toastify';

import {
  useGetShiftRequestsByShiftIdQuery,
} from '../../slices/shiftRequestApiSlice';


import {
  useGetAgenciesQuery,
} from '../../slices/agencyApiSlice';
import { useAssignShiftToAgencyMutation } from '../../slices/shiftApiSlice';
import {
  useGetShiftsQuery,
  useAssignShiftToUserMutation,
} from '../../slices/shiftApiSlice';
import { useGetApprovedFilledShiftsQuery } from '../../slices/shiftApiSlice';

//import { useGetShiftsQuery } from '../../slices/shiftApiSlice';



import { useUpdateShiftRequestStatusMutation } from '../../slices/shiftRequestApiSlice';



// Styled DataGrid with conditional row styles
const StyledDataGrid = styled(DataGrid)`
  & .${gridClasses.row}.lightGreenRow {
    background-color: ${lightGreen[100]};
  }
  & .${gridClasses.row}.redRow {
    background-color: ${red[100]};
  }
     & .${gridClasses.row}.lightOrangeRow {
    background-color: #ffe0b2; /* Light orange */
  }
  & .${gridClasses.row}.greenRow {
    background-color: #c8e6c9; /* Soft green */
  }

  & .${gridClasses.row}.darkGreenRow {
    background-color:rgb(149, 240, 152); /* Dark green */
  }

`;


//_________________________________________________________________________________________________________________________________
const ShiftWardListScreen = () => {
  const navigate = useNavigate();
  const [updateShiftRequestStatus] = useUpdateShiftRequestStatusMutation();

console.log("ShiftWardListScreen....",)
  const { data: shifts, isLoading, isError, error, refetch: refetchShifts } = useGetApprovedFilledShiftsQuery();    //useGetShiftsQuery();

 //console.log("ShiftWardListScreen..shifts are..",shifts)

const [openModal, setOpenModal] = React.useState(false);
const [selectedShift, setSelectedShift] = React.useState(null);
const [selectedShiftId, setSelectedShiftId] = useState(null);
const [selectedFiller, setSelectedFiller] = useState(null); // staff or agency object
const [isAgencyFilling, setIsAgencyFilling] = useState(false);
const [selectedShiftRow, setSelectedShiftRow] = useState(null);
  const { userInfo } = useSelector((state) => state.auth);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [assignShiftToAgency] = useAssignShiftToAgencyMutation();
  const { setFluid } = useLayout();

//__________________________________________________________________________________________________________________________________________________


const handleConfirmAssignment = async () => {
  try {
    if (!selectedShift || !selectedFiller) {
      toast.error('Please select both a shift and a filler');
      return;
    }

    if (isAgencyFilling) {
      // Call the agency assignment function
      await handleAgencyApprove(selectedFiller);
      refetch(); // This triggers a refresh
    } else {
      // Construct a fake request object to match handleApprove signature
      const request = {
        requestedBy: null , //selectedFiller._id,
        requestedByName: "" ,//selectedFiller.name,
        requestedByEmail: "" ,//selectedFiller.email,
        lineStatus: "Open"
      };
      await handleApprove(request);
     
    }

     // Find the approved request related to this shift (if any)
    const approvedRequest = shiftRequests?.find(
      (req) => req.lineStatus === "Approved"
    );

   //console.log("approvedRequest.........", approvedRequest)

    if (approvedRequest) {
      await updateShiftRequestStatus({
        shiftRequestId: approvedRequest._id,
        lineStatus: "Open",
      }).unwrap();
    }


 refetch(); // This triggers a refresh
await refetchShifts(); // ✅ refresh the main list

    setOpenConfirmModal(false);
    setOpenModal(false); 

    setSelectedShift(null);
    setSelectedFiller(null);
    toast.success('Shift Reset!');
  } catch (error) {
    console.error('Assignment failed:', error);
    toast.error('Failed to reset shift');
  }
};



//__________________________________________________________________________________________________________________________________________________



const handleAssignClick = (shift, filler, isAgency = false) => {

 //console.log("in handleAssignClick .shift...... ", shift)
 //console.log("in handleAssignClick ..filler..... ", filler.requestedByName)
 //console.log("in handleAssignClick .isAgency...... ", isAgency)

  setSelectedShift(shift);
  setSelectedFiller(filler); // this should be the filler (params.row), not the shift
  setSelectedShiftId(shift._id); // ✅ this line is critical
  setIsAgencyFilling(isAgency);
  setOpenConfirmModal(true);
};



  const {
    data: shiftRequests,
    refetch,
    isLoading: loadingRequests,
  } = useGetShiftRequestsByShiftIdQuery(selectedShiftId, {
    skip: !selectedShiftId,
  });

   const { data: agencies, isLoading: loadingAgencies } = useGetAgenciesQuery();


  const [assignShift] = useAssignShiftToUserMutation();




   //__________________________________________________________________________________________________________________________________________________
  
  
    const handleAgencyApprove = async (agency) => {
    try {
     //console.log('Assigning to agency:', agency);
  
      await assignShiftToAgency({
        shiftId: selectedShiftId,
        agencyId: null , //agency._id,
        agencyName: "", //agency.agencyName,
        agencyEmail: "", // agency.agencyEmail,
        managerId: userInfo._id,
        lineStatus: 'Open',
      }).unwrap();
  
      refetch(); // To reload shift data
    } catch (err) {
      console.error('Failed to assign shift to agency:', err);
    }
  };
  
  
    useEffect(() => {
     //console.log('Selected Shift ID:', selectedShiftId);
    }, [selectedShiftId]);
  
    useEffect(() => {
     //console.log('Fetched shiftRequests:', shiftRequests);
    }, [shiftRequests]);
  
    useEffect(() => {
      // Enable full-width container
      //setFluid(true);
  
      return () => {
        // Reset back to normal when screen unmounts
        setFluid(false);
      };
    }, [setFluid]);
  
    //const handleApprove = async (userId) => {
  
      //__________________________________________________________________________________________________________________________________________________
  
  
      const handleApprove = async (request) => {
      try {
   //console.log('approve codes. selectedShiftId:', selectedShiftId);
   //console.log('approve codes. userId:', request.requestedBy);
   //console.log('approve codes. userInfo._id:', userInfo._id);
  
    await assignShift({
      shiftId: selectedShiftId,
      userId: null, //request.requestedBy,
      userName: "", //"".requestedByName,
      userEmail: "", // request.requestedByEmail,
      managerId: userInfo._id,
      lineStatus: 'Open',
    }).unwrap();
  
    refetch();
  } catch (err) {
    console.error('Failed to assign shift:', err);
  }
    };
  
    //__________________________________________________________________________________________________________________________________________________
  


  const columns = [
   
  {
    field: 'startDateTime',
    headerName: 'Start Time',
    width: 180,
    type: 'dateTime',
        valueGetter: (params) => new Date(params.row.startDateTime),
        valueFormatter: (params) => new Date(params.value).toLocaleString(),
  },
  {
    field: 'endDateTime',
    headerName: 'End Time',
    width: 180,
    type: 'dateTime',
  valueGetter: (params) => new Date(params.row.endDateTime),
  valueFormatter: (params) => new Date(params.value).toLocaleString(),
  },
  
  { field: 'wardDepartmentArea', headerName: 'Ward/Dept Area', width: 150 },
  { field: 'categoryOfStaff', headerName: 'Staff Category', width: 150 },
  { field: 'lineStatus', headerName: 'Line Status', width: 120 },
  
  { field: 'filledByName', headerName: 'Filled By', width: 120 },

  {field: 'specialRequirements',         
    headerName: 'Special Requirements',
    width: 150,
    //valueGetter: (params) => params.row.hospitalLocationId?._id || 'N/A',
  },

  

  {
    field: 'actions',
    headerName: 'Actions',
    width: 120,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Button
        variant="contained"
        size="small"
        onClick={() => navigate(`/admin/shiftsWard/${params.row._id}/edit`)}
      >
        Approve
      </Button>
    ),
  },


  {/*
   {
      field: 'Re-Open',
      headerName: 'Re-Open',
      width: 120,
      
      renderCell: (params) => (
  <Button
    variant="contained"
    color="warning"
    size="small"
    onClick={async () => {
      await handleAssignClick(params.row, params.row, true); // pass the correct row twice
      refetch(); // This triggers a refresh
    }}
  >
    Re-Open
  </Button>
),
    },

*/}

];

/*{
    field: 'hospitalLocationId',         
    headerName: 'Hospital Location',
    width: -50,
    valueGetter: (params) => params.row.hospitalLocationId?._id || 'N/A',
  },*/


  // Function to apply row class based on shift end time
  
  /*
  const getRowClassName = (params) => {
    const now = new Date();
    const end = new Date(params.row.endDateTime);
    return end < now ? 'redRow' : 'lightGreenRow';
  };
  
  
  */

 const getRowClassName = (params) => {
  const now = new Date();
  const end = new Date(params.row.endDateTime);

  if (end < now) return 'redRow';

  const status = params.row.lineStatus?.toLowerCase();

  switch (status) {
    case 'open':
    case 'on hold':
      return 'lightOrangeRow';

    case 'archived':
    case 'filledbystaff':
    case 'filled':
    case 'complete':
      return 'greenRow';

    case 'filledbyagency':
      return 'darkGreenRow';

    case 'cancelled':
      return 'redRow';

    default:
      return 'lightGreenRow';
  }
};


  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Typography color="error">Error: {error.message}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: 'calc(100vh - 100px)', width: '100%', p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h4">Ward, Approve and update worked shifts</Typography>
        <Button
          variant="contained"
          color="primary"
          //onClick={() => navigate('/admin/shifts/create')}
          //onClick={() => navigate('/admin/shifts/create')}
        >
          Create Shift
        </Button>
      </Box>

     




      <StyledDataGrid
      density="compact"
        rows={shifts || []}
        columns={columns}
        getRowId={(row) => row._id}
        getRowClassName={getRowClassName}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
        sortModel={[{ field: 'startDateTime', sort: 'desc' }]}

        disableSelectionOnClick
        onRowClick={(params) => {
    setSelectedShift(params.row);
    setOpenModal(true);
  }}
      />

      <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="md" fullWidth>
  <DialogTitle>
    Shift Details
    <IconButton
      aria-label="close"
      onClick={() => setOpenModal(false)}
      sx={{ position: 'absolute', right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers>
    {selectedShift ? (
      <Box>
        <Typography variant="body1"><strong>Start:</strong> {new Date(selectedShift.startDateTime).toLocaleString()}</Typography>
        <Typography variant="body1"><strong>End:</strong> {new Date(selectedShift.endDateTime).toLocaleString()}</Typography>
        <Typography variant="body1"><strong>Ward/Dept:</strong> {selectedShift.wardDepartmentArea}</Typography>
        <Typography variant="body1"><strong>Category of Staff:</strong> {selectedShift.categoryOfStaff}</Typography>
        <Typography variant="body1"><strong>Line Status:</strong> {selectedShift.lineStatus}</Typography>
        <Typography variant="body1"><strong>Filled By:</strong> {selectedShift.filledByName || 'Unassigned'}</Typography>
        <Typography variant="body1"><strong>Special Requirements:</strong> {selectedShift.specialRequirements || 'None'}</Typography>
      </Box>
    ) : (
      <Typography>No shift selected.</Typography>
    )}
  </DialogContent>
 

   <DialogActions>
      <Button onClick={() => setOpenModal(false)}>Cancel</Button>
      <Button 
        onClick={handleConfirmAssignment} 
        color="primary" 
        variant="contained"
      >
        Confirm Shift ReSet
      </Button>
    </DialogActions>

</Dialog>

    </Box>
  );
};

export default ShiftWardListScreen;